import { makeFupIcon } from './FupIconFactory';
export default makeFupIcon('MIN');
